<template>
  <div>
    <el-dialog title="更换教材" :visible.sync="centerDialogVisible" top="20vh" width="29%">
      <div class="select-box">
        <el-select v-model="grade" placeholder="请选择">
          <el-option v-for="item in gradeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="books" v-if="bookList[grade]">
        <div class="book-item" :class="selectBookClass(book.bookId)" v-for="book in bookList[grade].books" :key="book.bookId" @click="selectBook(book.bookId,book)">
          <div class="book-img">
            <img :src="book.coverImgUrl" alt="">
          </div>
          <div class="version">{{book.versionName}}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '../utils/api.js'
import { Loading } from 'element-ui'
export default {
  name: 'SelectBookDialog',
  data () {
    return {
      centerDialogVisible: false,
      grade: 0,
      bookList: [],
      bookId: this.bookid,
      gradeOptions: []
    }
  },
  mounted () {
  },
  methods: {
    init () {
      let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      this.gradeOptions.forEach((g) => {
        if (g.gradeLevel === userInfo.bookInfo.gradeLevel && g.volume === userInfo.bookInfo.volume) {
          this.grade = g.id
        }
      })
      this.bookId = userInfo.bookInfo.bookId
      const loading = Loading.service()
      this.getBookList(() => {
        loading.close()
        this.centerDialogVisible = true
      })
    },
    getBookList (callback) {
      api.post('GetBookListRequest', {
        moduleType: 0,
        whiteListType: 6
      }, (res) => {
        let bookList = res.body.bookVersionList
        let myBookList = []
        this.gradeOptions = []

        let curMonth = (new Date()).getMonth() + 1
        for (let i = 0; i < bookList.length; i++) {
          // if (curMonth > 1 && curMonth < 7) { // 下册
          //   if (bookList[i].volume === 2) {
          //     myBookList.push(bookList[i])
          //   }
          // } else { // 上册
          //   if (bookList[i].volume === 1) {
          //     myBookList.push(bookList[i])
          //   }
          // }
          myBookList.push(bookList[i])
        }
        for (let j = 0; j < myBookList.length; j++) {
          this.gradeOptions.push({
            id: j,
            gradeLevel: myBookList[j].gradeLevel,
            name: myBookList[j].gradeLevelName + myBookList[j].volumeName,
            volume: myBookList[j].volume
          })
        }
        // this.bookList = res.body.bookVersionList
        this.bookList = myBookList
        this.bookList[0].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:968,
          bookName:"沪教版（深圳）英语一年级上册",    // 书本名
          coverImgUrl:"http://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2025/08/18/eNyZjj6bZ8.png",   // 书本封面
          gradeLevel:40,
          gradeLevelName:"一年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:1,
          volumeName:"上册",
        })
        this.bookList[2].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:969,
          bookName:"沪教版（深圳）英语二年级上册",    // 书本名
          coverImgUrl:"http://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2025/08/19/rpedM7Knxj.jpg",   // 书本封面
          gradeLevel:50,
          gradeLevelName:"二年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:1,
          volumeName:"上册",
        })
        this.bookList[4].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:888,
          bookName:"沪教版（深圳）小学英语三年级上册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2024/08/28/QpxjndKsWS.jpg",   // 书本封面
          gradeLevel:60,
          gradeLevelName:"三年级",
          versionId:106,
          versionName:"沪教版（深圳）",   // 版本名
          volume:1,
          volumeName:"上册",
        })
        this.bookList[5].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:922,
          bookName:"沪教版（深圳）小学英语三年级下册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2025/01/22/A5wHttHa2n.png",   // 书本封面
          gradeLevel:60,
          gradeLevelName:"三年级",
          versionId:106,
          versionName:"沪教版（深圳）",   // 版本名
          volume:2,
          volumeName:"下册",
        })
        this.bookList[6].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:970,
          bookName:"沪教版（深圳）英语四年级上册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2025/07/14/KJJCnGejdj.jpg",   // 书本封面
          gradeLevel:70,
          gradeLevelName:"四年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:1,
          volumeName:"上册",
        })
        this.bookList[1].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:994,
          bookName:"沪教版（深圳）2024小学英语一年级下册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2026/01/21/C5k4YK77Q2.png",   // 书本封面
          gradeLevel:40,
          gradeLevelName:"一年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:2,
          volumeName:"下册",
        })
        this.bookList[3].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:995,
          bookName:"沪教版（深圳）2024小学英语二年级下册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2026/01/27/hzEEBrzKQE.png",   // 书本封面
          gradeLevel:50,
          gradeLevelName:"二年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:2,
          volumeName:"下册",
        })
        this.bookList[7].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:987,
          bookName:"沪教版（深圳）2024小学英语四年级下册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2026/02/10/f46waQQf5j.jpg",   // 书本封面
          gradeLevel:70,
          gradeLevelName:"四年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:2,
          volumeName:"下册",
        })
        this.bookList[8].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:1087,
          bookName:"沪教版（深圳）2024小学英语五年级上册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2026/08/03/rAxib7XbSh.jpg",   // 书本封面
          gradeLevel:80,
          gradeLevelName:"五年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:1,
          volumeName:"上册",
        })
        this.bookList[10].books.push({
          areaId:460200,
          areaName:"三亚市",
          bookId:1088,
          bookName:"沪教版（深圳）2024小学英语六年级上册",    // 书本名
          coverImgUrl:"https://tbxcdnnew.kingsun.cn/pro/cbss/cbssadmin/2026/08/04/c7fmHHTjKD.jpg",   // 书本封面
          gradeLevel:90,
          gradeLevelName:"六年级",
          versionId:6,
          versionName:"沪教版（深圳）",   // 版本名
          volume:1,
          volumeName:"上册",
        })
        console.log('bookList`:', this.bookList) 
        if (callback) {
          callback()
        }
      })
    },
    selectBook (bookId, bookInfo) {
      let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      this.bookId = bookId
      api.post('ChooseTeacherBookRequest', {
        bookId: this.bookId,
        moduleType: userInfo.moduleType
      }, (res) => {
        userInfo.bookInfo = bookInfo
        window.sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
        this.reloadInfo(userInfo)
        this.$store.dispatch('setUsrinfo', userInfo)
        this.centerDialogVisible = false
        this.$message({
          message: '换书成功',
          type: 'success'
        })
      })
    },
    selectBookClass (bookId) {
      console.log(bookId)
      if (bookId === this.bookId) {
        return {
          active: true
        }
      }
    },
    reloadInfo (userInfo) {
      this.$emit('reloadInfo', userInfo)
    }
  }
}
</script>
<style scoped>
.select-box{
  text-align: center;
  margin-bottom: 20px;
}
.book-item{
  border: 1px solid #fff;
  display: inline-block;
  height: 181px;
  width: 118px;
  text-align: center;
  padding: 9px;
  box-sizing: border-box;
  margin-right: 10px;
}
.book-item.active{
  border-color: #FE793A;
}
.book-item .book-img img{
  width: 98px;
  height: 141px;
}
.book-item:hover{
  border: 1px #ddd solid;
}

</style>
